import { forwardRef, ReactElement } from "react";
import { HStack, Text } from "@chakra-ui/react";
import { components, ValueContainerProps, Props } from "chakra-react-select";

import Select from "./Select";

const LimitedChipsContainer = ({
  children,
  hasValue,
  ...props
}: ValueContainerProps) => {
  if (!hasValue) {
    return (
      <components.ValueContainer hasValue={hasValue} {...props}>
        {children}
      </components.ValueContainer>
    );
  }

  const [chips, ...otherChildren] = children as ReactElement[][];
  const overflowCounter = chips.length - 1;

  return (
    <components.ValueContainer hasValue={hasValue} {...props}>
      <HStack align="center" spacing={2}>
        <Text whiteSpace="nowrap" textStyle="body2" fontWeight="semibold">
          {chips[0]}
        </Text>
        <Text whiteSpace="nowrap" textStyle="labelSmall" fontWeight="semibold">
          {overflowCounter > 0 && `+ ${overflowCounter}`}
        </Text>
      </HStack>
      {otherChildren}
    </components.ValueContainer>
  );
};

const FilterMultiSelect = forwardRef<any, Props>(
  (props: Props, ref): ReactElement => (
    <Select
      ref={ref}
      isClearable={false}
      isMulti={true}
      isSearchable={false}
      components={{ ValueContainer: LimitedChipsContainer }}
      {...props}
    />
  )
);

FilterMultiSelect.displayName = "MultiSelect";

export default FilterMultiSelect;
